import React, { useState } from 'react';
import { Countdown, Button, TrustBar } from './Shared';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
type Option = {
  id: string;
  icon: string;
  name: string;
  detail: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  top?: boolean;
  save?: string;
};
const OPTIONS: Option[] = [{
  id: 't1',
  icon: '📘',
  name: 'PACK TRAMO 1 · Inicial',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 1 →',
  href: 'https://tufenixdigital.store/cart/53832899985772:1'
}, {
  id: 't2',
  icon: '📗',
  name: 'PACK TRAMO 2 · 1° y 2°',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 2 →',
  href: 'https://tufenixdigital.store/cart/53939688046956:1'
}, {
  id: 'mega',
  icon: '🏆',
  name: 'MEGAPACK AULA DE EXITOS BUSINESS',
  detail: '32 tomos + 24 bonos + 1.600 actividades + Guía de Monetización',
  oldPrice: '$7.960',
  price: '$2.490',
  cta: '⭐ QUIERO EL MEGAPACK AHORA →',
  href: 'https://tufenixdigital.store/cart/53889590722924:1',
  top: true,
  save: 'AHORRÁS $5.470'
}, {
  id: 't3',
  icon: '📙',
  name: 'PACK TRAMO 3 · 3° y 4°',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 3 →',
  href: 'https://tufenixdigital.store/cart/53939663012204:1'
}, {
  id: 't4',
  icon: '📓',
  name: 'PACK TRAMO 4 · 5° y 6°',
  detail: '8 tomos + 6 bonos + 400 actividades',
  oldPrice: '$1.990',
  price: '$890',
  cta: '🟠 COMPRAR PACK TRAMO 4 →',
  href: 'https://tufenixdigital.store/cart/53939690602860:1'
}];
export function Precios() {
  const [selected, setSelected] = useState('mega');
  const current = OPTIONS.find(o => o.id === selected) ?? OPTIONS[2];
  return <>
      {/* SECCIÓN 6: URGENCIA */}
      <section className="py-12 px-4 bg-orange-50 border-y border-orange-100 text-center" data-id="element-150">
        <div className="max-w-3xl mx-auto" data-id="element-151">
          <div className="inline-block bg-red-100 text-red-700 px-4 py-1 rounded-full text-sm font-bold mb-4 flex items-center justify-center gap-2 w-max mx-auto" data-id="element-152">
            <span className="w-2 h-2 rounded-full bg-red-600 animate-pulse" data-id="element-153"></span>
            Cupos limitados · Quedan pocos
          </div>
          <h2 className="text-2xl md:text-3xl font-display font-bold text-brand-deep mb-4" data-id="element-154">
            ⏰ PRECIO DE LANZAMIENTO TERMINA EN:
          </h2>
          <Countdown data-id="element-155" />
          <p className="text-lg text-brand-text font-medium mt-4" data-id="element-156">
            Después vuelve a su precio real y no vuelve esta oferta.
          </p>
        </div>
      </section>

      {/* SECCIÓN 7: PRECIOS */}
      <section id="precios" className="py-16 px-4 bg-brand-base scroll-mt-10" data-id="element-157">
        <div className="max-w-xl mx-auto" data-id="element-158">
          <div className="text-center mb-10" data-id="element-159">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-deep mb-3" data-id="element-160">
              ELEGÍ TU <span className="text-brand-orange" data-id="element-161">AULA DE ÉXITOS</span>
            </h2>
            <p className="text-lg text-brand-text font-medium" data-id="element-162">
              Todas las opciones incluyen los tomos completos · los 6 bonos
              estratégicos y 400 actividades listas para usar.
            </p>
          </div>

          {/* Selectable rows */}
          <div role="radiogroup" aria-label="Opciones de compra" className="space-y-4 mb-8" data-id="element-163">
            {OPTIONS.map((opt, i) => {
            const isActive = selected === opt.id;
            return <button key={opt.id} type="button" role="radio" aria-checked={isActive} onClick={() => setSelected(opt.id)} className={`relative w-full text-left rounded-2xl p-4 md:p-5 border-2 transition-all flex items-center gap-4 ${isActive ? 'border-brand-orange bg-orange-50 shadow-[0_8px_24px_rgba(245,124,0,0.18)]' : 'border-gray-200 bg-white hover:border-brand-sky'}`} data-id="element-164">
                  {/* TOP badge */}
                  {opt.top && <span className="absolute -top-3 right-4 bg-brand-orange text-white text-xs font-bold px-3 py-0.5 rounded-full shadow-md" data-id="element-165">
                      ⭐ TOP
                    </span>}

                  {/* Radio */}
                  <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isActive ? 'border-brand-orange' : 'border-gray-300'}`} data-id="element-166">
                    {isActive && <span className="w-3 h-3 rounded-full bg-brand-orange" data-id="element-167" />}
                  </span>

                  {/* Label */}
                  <div className="flex-1 min-w-0" data-id="element-168">
                    <div className="font-display font-bold text-brand-deep text-base md:text-lg flex items-center gap-2 flex-wrap" data-id="element-169">
                      <motion.span className="text-xl inline-block" animate={{
                    rotate: [0, -8, 8, -8, 0],
                    y: [0, -2, 0]
                  }} transition={{
                    duration: 2.4,
                    repeat: Infinity,
                    repeatDelay: 1.2,
                    ease: 'easeInOut',
                    delay: i * 0.25
                  }} data-id="element-170">
                        {opt.icon}
                      </motion.span>
                      <span data-id="element-171">{opt.name}</span>
                    </div>
                    <div className="text-sm text-brand-text mt-0.5" data-id="element-172">
                      {opt.detail}
                    </div>
                    {opt.save && <span className="inline-block mt-2 bg-brand-greenSoft text-brand-green border border-green-200 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-173">
                        🟢 {opt.save}
                      </span>}

                    {/* Mini CTA por oferta */}
                    <a href={opt.href} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="mt-2 inline-flex items-center gap-1 bg-brand-orange hover:bg-[#EF6C00] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm transition-colors active:scale-95" data-id="element-174">
                      Lo quiero ahora!
                      <ArrowRight className="w-3 h-3" data-id="element-175" />
                    </a>
                  </div>

                  {/* Price */}
                  <div className="flex-shrink-0 text-right" data-id="element-176">
                    <div className="text-brand-gray line-through text-sm font-medium" data-id="element-177">
                      {opt.oldPrice}
                    </div>
                    <div className="font-display font-bold text-brand-deep text-2xl md:text-3xl" data-id="element-178">
                      {opt.price}
                    </div>
                    <div className="text-xs text-brand-gray font-semibold" data-id="element-179">
                      UY
                    </div>
                  </div>
                </button>;
          })}
          </div>

          {/* Dynamic CTA */}
          <motion.div key={current.id} initial={{
          opacity: 0.6
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.2
        }} data-id="element-180">
            <Button href={current.href} variant={current.id === 'mega' ? 'success' : 'primary'} className="py-5 text-lg md:text-xl" data-id="element-181">
              {current.cta}
            </Button>
          </motion.div>

          <motion.p animate={{
          opacity: [0.65, 1, 0.65]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="mt-4 text-center text-sm font-semibold text-brand-orange flex items-center justify-center gap-1.5" data-id="element-182">
            <motion.span aria-hidden="true" animate={{
            scale: [1, 1.3, 1],
            rotate: [0, -12, 12, 0]
          }} transition={{
            duration: 1.4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="inline-block" data-id="element-183">
              ⚡
            </motion.span>
            El precio actual es exclusivo para los primeros 200 compradores
          </motion.p>

          <div className="mt-6" data-id="element-184">
            <TrustBar data-id="element-185" />
          </div>

          <div className="mt-16 bg-white p-8 rounded-3xl border border-brand-sky shadow-sm" data-id="element-186">
            <h3 className="text-2xl font-display font-bold text-brand-deep mb-6 text-center" data-id="element-187">
              Por qué el MegaPack AULA DE EXITOS BUSINESS es la decisión más
              inteligente
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-188">
              <div className="p-5 bg-gray-50 rounded-xl border border-gray-200" data-id="element-189">
                <p className="font-bold text-brand-deep mb-2" data-id="element-190">
                  SI COMPRÁS UN TRAMO POR $890 ·
                </p>
                <p className="text-sm text-brand-text" data-id="element-191">
                  Tenés el año resuelto, es una solución puntual para ese tramo,
                  pensada para quienes no necesitan una propuesta más amplia.
                </p>
              </div>
              <div className="p-5 bg-brand-lightBlue rounded-xl border border-brand-sky" data-id="element-192">
                <p className="font-bold text-brand-blue mb-2" data-id="element-193">
                  SI COMPRÁS EL MEGAPACK AULA DE EXITO BUSINESS POR $2.490 ·
                </p>
                <p className="text-sm text-brand-text" data-id="element-194">
                  Tenés toda la primaria uruguaya cubierta. Podés atender a
                  cualquier niño sin importar el año que curse. Nunca más tenés
                  que decirle "no" a un padre porque no tenés material de ese
                  tramo. Recuperás la inversión en 4 horas de clases. A partir
                  de la quinta hora todo es ganancia pura, de por vida.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}